import alert from './alert.vue';
let $vm
export default {
	install(Vue, options) {
		if (!$vm) {
			const AlertPlugin = Vue.extend(alert);
			$vm = new AlertPlugin({
				el: document.createElement('div')
			});
			document.body.appendChild($vm.$el);
		}
		$vm.isShow = false;
		let alertPlugin = {
			show(optiones = {}) {
				optiones = optiones || "";
				$vm.isShow = true;
				$vm.title = optiones.title; //为了使confirm的扩展性更强，这个采用对象的方式传入，所有的字段都可以根据需求自定义
				$vm.content = optiones.content; //为了使confirm的扩展性更强，这个采用对象的方式传入，所有的字段都可以根据需求自定义
				$vm.width = optiones.width || 280;
				$vm.theme = window.localStorage.getItem('theme')?window.localStorage.getItem('theme'):'';
				$vm.confirmText = optiones.confirmText ? optiones.confirmText : '确定'; //为了使confirm的扩展性更强，这个采用对象的方式传入，所有的字段都可以根据需求自定义
				$vm._onConfirm = function () {
					if (optiones.onConfirm) {
						optiones.onConfirm();
					}
					$vm.isShow = false
				}
			},
			hide() {
				$vm.isShow = false;
			}
		};

		Vue.prototype.$alert = alertPlugin;
		/*if (!Vue.$alert) {
			Vue.$alert = alert;
		}*/
		// Vue.prototype.$loading = Vue.$loading;

		/*Vue.mixin({
			created() {
				this.$alert = Vue.$alert;
			}
		})*/
	}
}



// WEBPACK FOOTER //
// ./src/components/alertPlugin/alert.js